var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as templateHooks from "@rentiohq/shared-frontend/dist/redux/template/template.hooks";
import { signOutStart } from "@rentiohq/shared-frontend/dist/reduxV2/auth/auth.actions";
import * as documentActions from "@rentiohq/shared-frontend/dist/reduxV2/documents/document.actions";
import * as templateDocumentActions from "@rentiohq/shared-frontend/dist/reduxV2/templateDocuments/templateDocument.actions";
import * as templateDocumentHooks from "@rentiohq/shared-frontend/dist/reduxV2/templateDocuments/templateDocument.hooks";
import { ESendType, } from "@rentiohq/shared-frontend/dist/reduxV2/templateDocuments/templateDocument.types";
import { EDocumentPackageTypes } from "@rentiohq/shared-frontend/dist/types/documentPackage.types";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { appendQueryParams } from "@rentiohq/shared-frontend/dist/utils/url.utils";
import { convertToRaw } from "draft-js";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Error } from "../../components";
import * as systemActions from "../../redux/system/system.actions";
import { EPreferencePersistScope } from "../../redux/system/system.types";
import { redirectPage } from "../../utils/redirect";
import Editor from "../TemplateEditor/components/Editor";
import { EDisplayType, } from "../TemplateEditor/components/Editor/Editor.types";
import { EExternalViewType } from "./scenes/TemplateDocumentExternal/TemplateDocumentExternal.types";
import { useParsedTemplateDocument } from "./TemplateDocumentEditor.hooks";
import { getTemplateDocumentUpdateData } from "./TemplateDocumentEditor.utils";
var TemplateDocumentEditor = function (props) {
    var sendToTenant = props.sendToTenant, _a = props.externalViewType, externalViewType = _a === void 0 ? EExternalViewType.Dashboard : _a;
    // Router
    var navigate = useNavigate();
    var paramTemplateDocumentId = useParams().templateDocumentId;
    var templateDocumentId = paramTemplateDocumentId || props.templateDocumentId;
    // Redux
    var dispatch = useDispatch();
    // INFO: v2 returns every field on the detail endpoint, so a single read replaces the separate
    // light and full fetches the v1 module needed
    var _b = templateDocumentHooks.useDetail({
        shouldRefetch: true,
        id: templateDocumentId,
    }), templateDocument = _b.detail, isFetching = _b.isFetching, fetchError = _b.fetchError;
    var template = templateHooks.useDetail({
        shouldRefetch: false,
        id: templateDocument === null || templateDocument === void 0 ? void 0 : templateDocument.templateId,
    }).detail;
    var isUpdatingDetail = templateDocumentHooks.useUpdate({
        id: templateDocumentId,
    }).isUpdating;
    var _c = useParsedTemplateDocument(templateDocument), rawState = _c.rawState, fields = _c.fields, variablesData = _c.variablesData, documentConfig = _c.documentConfig;
    var canEdit = useState(!!(template === null || template === void 0 ? void 0 : template.tenantCanEdit))[0];
    // Event handlers
    var handlePressSave = function (params) {
        var withGeneratePdf = params.withGeneratePdf, newEditorState = params.editorState, newFields = params.fields, newVariablesData = params.variablesData, newDocumentConfig = params.documentConfig, documentIds = params.documentIds, goBackOnSuccess = params.goBackOnSuccess, _a = params.tenantCanEdit, tenantCanEdit = _a === void 0 ? false : _a, sendForSigning = params.sendForSigning;
        if (!templateDocumentId || !newVariablesData) {
            return;
        }
        // Store values in preferences
        var preferences = {};
        (newFields.variables || []).forEach(function (variable) {
            if (variable.persisted) {
                preferences["template_document:field:".concat(variable.id)] =
                    newVariablesData[variable.id];
            }
        });
        if (Object.keys(preferences).length > 0) {
            dispatch(systemActions.setPreferences({
                persistScope: EPreferencePersistScope.RemoteBroker,
                preferences: preferences,
            }));
        }
        var generateTemplateData = function () {
            if (tenantCanEdit) {
                return {
                    sendType: ESendType.Tenant,
                };
            }
            if (sendForSigning) {
                return {
                    sendType: ESendType.Signing,
                };
            }
            return {};
        };
        // Update, generate PDF & navigate
        dispatch(templateDocumentActions.updateStart.getAction({
            id: templateDocumentId,
            data: getTemplateDocumentUpdateData({
                isExternalTenantSubmit: !!sendToTenant,
                stored: {
                    documentIds: (templateDocument === null || templateDocument === void 0 ? void 0 : templateDocument.documentIds) || [],
                    fields: fields,
                    variablesData: variablesData,
                },
                submitted: {
                    data: convertToRaw(newEditorState.getCurrentContent()),
                    documentConfig: newDocumentConfig,
                    documentIds: documentIds,
                    fields: newFields,
                    variablesData: newVariablesData,
                },
            }),
            suppressSuccessAlert: withGeneratePdf,
            onSuccess: function () {
                if (withGeneratePdf) {
                    dispatch(templateDocumentActions.generateDocumentStart.getAction(__assign(__assign({ id: templateDocumentId }, generateTemplateData()), { suppressSuccessAlert: tenantCanEdit, customSuccessMessage: sendForSigning
                            ? getLocalizedText("editor.template_document.send_for_signing.alert.success")
                            : undefined, onSuccess: function (updatedTemplateDocument) {
                            if (tenantCanEdit) {
                                var documentId = updatedTemplateDocument === null || updatedTemplateDocument === void 0 ? void 0 : updatedTemplateDocument.documentId;
                                dispatch(documentActions.getDetailStart.getAction({
                                    id: documentId,
                                    onSuccess: function () {
                                        navigate(appendQueryParams({
                                            path: "/forms/document-package",
                                            queryParams: {
                                                propertyId: updatedTemplateDocument === null || updatedTemplateDocument === void 0 ? void 0 : updatedTemplateDocument.propertyId,
                                                contractId: (updatedTemplateDocument === null || updatedTemplateDocument === void 0 ? void 0 : updatedTemplateDocument.contractId) ||
                                                    undefined,
                                                documentIdToSign: updatedTemplateDocument === null || updatedTemplateDocument === void 0 ? void 0 : updatedTemplateDocument.documentId,
                                                sendToTenant: 1,
                                                documentPackageType: EDocumentPackageTypes.Contract,
                                            },
                                        }));
                                    },
                                }));
                            }
                            else if (sendForSigning) {
                                dispatch(signOutStart.getAction());
                                setTimeout(function () {
                                    redirectPage(getLocalizedText("template.document.send_for_signing.redirect_url"));
                                }, 500);
                            }
                            else {
                                navigate(-1);
                            }
                        } })));
                }
                if (goBackOnSuccess) {
                    navigate(-1);
                }
            },
        }));
    };
    // Render
    var error = fetchError;
    if (error) {
        return _jsx(Error, { errors: [error] });
    }
    return (_jsx(Editor, { displayType: sendToTenant
            ? EDisplayType.TemplateDocumentExternal
            : EDisplayType.TemplateDocument, templateDocumentId: templateDocumentId, title: templateDocument === null || templateDocument === void 0 ? void 0 : templateDocument.name, onPressSave: handlePressSave, isFetching: isFetching, isUpdating: isUpdatingDetail, canEdit: canEdit, rawState: rawState, fields: fields, variablesData: variablesData, documentConfig: documentConfig, documentIds: (templateDocument === null || templateDocument === void 0 ? void 0 : templateDocument.documentIds) || [], externalViewType: externalViewType }));
};
// eslint-disable-next-line import/no-default-export
export default TemplateDocumentEditor;
